<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        has-feedback
        :label="$t('table.icon.thead.name')"
        style="margin-bottom: 0px"
      >
        <a-input
          v-model="searchForm.name"
          :placeholder="$t('table.icon.thead.name')"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">
          {{ $t(`actionTitles.submit`) }}
        </a-button>
      </a-form-model-item>
      <a-form-model-item layout="vertical">
        <a-button
          type="primary"
          :style="{ margin: '0px 15px' }"
          @click="addIcon"
          >{{$t('actionTitles.add')}}</a-button
        >
      </a-form-model-item>
    </a-form-model>

    <div class="table-wrapper">
      <a-table
        :data-source="pageResult.data"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column
          key="id"
          :title="$t('table.icon.thead.id')"
          data-index="id"
          align="center"
        ></a-table-column>
        <a-table-column
          key="name"
          :title="$t('table.icon.thead.name')"
          data-index="name"
          align="center"
        />
        <a-table-column
          key="thumb_path"
          :title="$t('table.icon.thead.thumb')"
          data-index="thumb_path"
          align="center"
        >
          <template slot-scope="text, record">
            <div>
              <img
                :src="record.thumb_path"
                alt
                style="width: 40px; height: 40px"
              />
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="type"
          :title="$t('form.common.field.type.label')"
          data-index="type"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.type === 1 ? $t('enum.iconCate.1') : $t('enum.iconCate.2') }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="is_dynamic"
          :title="$t('table.icon.thead.type')"
          data-index="is_dynamic"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.is_dynamic === 1 ? $t('enum.iconType.1') : $t('enum.iconType.0') }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="sort_order"
          :title="$t('table.common.thead.sort')"
          data-index="sort_order"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ record.sort_order }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="detail(record.id)">{{
                $t(`actionTitles.edit`)
              }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteInfo(record.id)"
              >
                <a href="javascript:;" style="color: red">
                  {{ $t(`actionTitles.delete`) }}
                </a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <!-- 彈窗 -->
    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="save"
      @cancel="close"
      keyboard
    >
      <a-form-model
        ref="form"
        layout="vertical"
        :model="form"
        :rules="rules"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item
          :label="$t('form.icon.field.name.label')"
          prop="name"
        >
          <a-input
            v-model="form.name"
            :placeholder="$t('form.icon.field.name.placeholder')"
          />
        </a-form-model-item>
        <a-form-model-item
          :label="$t('form.icon.field.cate.label')"
          ref="cate"
          prop="type"
        >
          <a-select
            :placeholder="$t('form.icon.field.cate.placeholder')"
            v-model="form.type"
          >
            <a-select-option :value="1">
              {{ $t("enum.iconCate.1") }}
            </a-select-option>
            <a-select-option :value="2">
              {{ $t("enum.iconCate.2") }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('form.icon.field.type.label')"
          ref="type"
          prop="is_dynamic"
        >
          <a-select
            :placeholder="$t('form.icon.field.type.placeholder')"
            v-model="form.is_dynamic"
          >
            <a-select-option :value="0">
              {{ $t("enum.iconType.0") }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t("enum.iconType.1") }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="sort_order" :label="$t('table.common.thead.sort')" prop="sort_order">
          <a-input-number v-model="form.sort_order" :min="0"   :placeholder="$t('message.sortTip')"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('form.icon.field.icon.label')">
          <div style="height: 100%">
            <div style="margin-bottom: 5px; width: 400px" v-if="form.icon_url">
              <img :src="form.icon_url" style="width: 50px; height: 50px" alt />
            </div>
            <DragUploader ref="uploader" uptype="icon" :callback="getUploader">
              <a-spin
                :spinning="uploading"
                :tip="$t('message.uploading')"
                slot="body"
              >
                <a-button type="primary">
                  {{ $t("message.uploadBtn") }}
                </a-button>
              </a-spin>
            </DragUploader>
          </div>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('form.icon.field.thumb.label')"
          v-show="form.is_dynamic === 1"
        >
          <div style="height: 100%">
            <div
              style="margin-bottom: 5px; width: 400px"
              v-if="form.thumb_path"
            >
              <img
                :src="form.thumb_path"
                style="width: 50px; height: 50px"
                alt
              />
            </div>
            <DragUploader
              ref="uploaderThumb"
              uptype="icon"
              :callback="getThumbUploader"
            >
              <a-spin
                :spinning="thumbUploading"
                :tip="$t('message.uploading')"
                slot="body"
              >
                <a-button type="primary">
                  {{ $t("message.uploadBtn") }}
                </a-button>
              </a-spin>
            </DragUploader>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import { pageQuery, save, deleteInfo, detail } from "@/api/icon";
import DragUploader from "@/components/DragUploader";

export default {
  components: {
    DragUploader,
  },
  data() {
    return {
      searchForm: {
        current_page: 1,
        per_page: 10,
        name: "",
      },
      pageResult: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      modelTitle: "",
      form: {
        name: "",
        is_dynamic: null,
        type: null,
        icon_url: "",
        thumb_path: "",
        sort_order: 99,
      },
      exitVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.icon.field.name.message"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("form.icon.field.cate.message"),
            trigger: "change",
          },
        ],
        is_dynamic: [
          {
            required: true,
            message: this.$t("form.icon.field.type.message"),
            trigger: "change",
          },
        ],
      },
      uploading: false,
      thumbUploading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQuery(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.pageResult = res.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchParam.order = order;
      }
      this.loadData();
    },

    handleReset() {
      this.form = {
        name: "",
        icon_url: "",
        thumb_path: "",
        sort_order: 99,
      };
      this.$refs.form.resetFields();
    },
    close() {
      this.exitVisible = false;
      this.$refs.form.resetFields();
    },
    addIcon() {
      this.modelTitle = this.$t("actionTitles.add");
      this.exitVisible = true;
      setTimeout(() => {
        this.handleReset();
      }, 0);
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.icon_url) {
            this.$message.error(this.$t("message.uploadPicErr"),2);
            return 
          }
          if (this.form.is_dynamic === 0) {
            this.form.thumb_path = this.form.icon_url;
          }
          save(this.form).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"));
            this.exitVisible = false;
            this.loadData();
          });
        }
      });
    },

    detail(id) {
      this.modelTitle = this.$t("actionTitles.edit");
      detail({ id: id })
        .then((res) => {
          this.form = res.data;
          this.exitVisible = true;
        })
        .catch((err) => {});
    },
    deleteInfo(id) {
      deleteInfo({ id: id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
            });
          }
        })
        .catch((err) => {});
    },
    //回調方法，up為上傳實例對像
    getUploader(up) {
      this.$nextTick(() => {
        up.bind("FilesAdded", (up, file) => {
          this.uploading = true;
        });
        up.bind("Error", (up, file) => {
          this.uploading = false;
        });
        up.bind("UploadComplete", (up, file) => {
          this.uploading = false;
          this.form.icon_url = this.$refs.uploader.fileList[0].url;
        });
      });
    },
    // 上傳縮率圖
    getThumbUploader(up) {
      this.$nextTick(() => {
        up.bind("FilesAdded", (up, file) => {
          this.thumbUploading = true;
        });
        up.bind("Error", (up, file) => {
          this.thumbUploading = false;
        });
        up.bind("UploadComplete", (up, file) => {
          this.thumbUploading = false;
          this.form.thumb_path = this.$refs.uploaderThumb.fileList[0].url;
        });
      });
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    }
  },
};
</script>
<style lang="less" scoped>
.ant-input-number {
  width: 100%;
}
</style>
